import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sa-input-text',
  templateUrl: './sa-input-text.component.html',
  styleUrls: ['../formfields.css']
})
export class SainputtextComponent implements OnInit {
  @Input() text = "";
  @Input() title = "";
  @Input() id="";
  @Input() required = "none"; // P.S. can be 'text' (if required) or 'none' if not required

  @Output() textChange = new EventEmitter();
  @Output() hasChanged = new EventEmitter();

  isValid = true;
  tiClass = { 'border': 'solid 1px gray' }; // {'background-color':'green'};
  constructor() { }
  ngOnInit(): void {

  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewChecked() {
    this.doValidation(this.text);
  }
  change(newValue: any) { // P.S. newValue has the changed text
    this.doValidation(newValue);
    this.text = newValue;

    // P.S. Synchronize the text with the model of the parent
    this.textChange.emit(newValue);
    // P.S. send the parent the message whether validation is true or false
    this.hasChanged.emit(this.isValid);
  };

  doValidation = function (this: any, newValue: any) {
    // P.S. implement your validation rules here
    if (this.required == 'required') {
      if (!newValue || newValue == '') {
        this.isValid = false;
        this.tiClass = { 'border': 'solid 2px red' };
      } else {
        this.isValid = true;
        this.tiClass = { 'border': 'solid 1px gray' };
      }
    }
  };
}
